import {ChangePasswordController} from './change-password.controller';
import {ChangePasswordForm} from './change-password-form.model';
import {ChangePasswordState} from './change-password.state';
import {getRootStore, createFieldModel} from '../../app.bootstrap';
import {IRouteStore} from '../../router/routing.infra';
import {ILocalizationService} from '../../services/LocalizationService';
import {IAccountData} from '@techsee/techsee-common/lib/constants/account.constants';
import {resolveLogoUrl} from '../../utils/logo-url.utils';

export interface CurrentUser {
    _id: string;
    accountId: string;
}

export interface IChangePasswordStore extends IRouteStore {
    changePasswordController: ChangePasswordController;
    localizationService: ILocalizationService;
    accountLogo: string;
    dispose(): void;
}

export class ChangePasswordStore implements IChangePasswordStore {
    public changePasswordController: ChangePasswordController;
    public localizationService: ILocalizationService;
    public accountLogo: string;

    constructor(currentUser: CurrentUser, accountData: IAccountData) {
        const rootStore = getRootStore();
        this.localizationService = rootStore.localizationService;

        const userId = currentUser._id;
        const passwordSettings = (accountData?.settings as any)?.passwordSettings;
        const allowCustom = (accountData?.protectedSettings as any)?.allowCustomPasswordPolicy;

        const changePasswordForm = new ChangePasswordForm(
            this.localizationService.translate,
            createFieldModel,
            passwordSettings,
            allowCustom
        );

        const changePasswordState = new ChangePasswordState();
        this.changePasswordController = new ChangePasswordController(
            this.localizationService.translate,
            rootStore.tsLocaleHelper,
            userId,
            rootStore.tsReactStateHelper,
            changePasswordForm,
            rootStore.userService,
            changePasswordState
        );

        const logoUrl = accountData?.settings?.logoUrl;
        this.accountLogo = resolveLogoUrl(logoUrl);
    }

    dispose(): void {}
}
